<div class="sort-container" [class]="styleType" (click)="isOpen ? dropdown.hide() : dropdown.show()">
  <span>Sort By:</span>
  <p-dropdown
    (click)="onDropdownClick($event)"
    #dropdown
    optionLabel="name"
    [(ngModel)]="selectedSort"
    [options]="sortOptions"
    (onShow)="onShow()"
    (onHide)="onHide()"
    (onChange)="sortBy($event)">
  </p-dropdown>
</div>
